import type { Router } from 'vue-router';
import type { NxCommand } from '@blpde/nx-ui';

/**
 * One app-wide palette entry that opens a location of the app — often with a
 * one-shot action in its query (`/wiki?new=page`), which the app's view runs
 * through `useRouteIntent` (`@blpde/connect`). Shared by the apps' command
 * factories (I-2348).
 */
export function appLocationCommand(
  router: Router,
  entry: {
    id: string;
    app: string;
    group: string;
    label: string;
    href: string;
    icon?: NxCommand['icon'];
    keywords?: string[];
    hint?: string;
    category?: NxCommand['category'];
  },
): NxCommand {
  return {
    id: entry.id,
    label: entry.label,
    hint: entry.hint,
    group: entry.group,
    app: entry.app,
    icon: entry.icon,
    category: entry.category ?? 'action',
    keywords: entry.keywords,
    href: entry.href,
    run: () => {
      void router.push(entry.href);
    },
  };
}
